import styled from 'styled-components';

import {
  ForgotPasswordBG,
  IconShowPassword,
  IconHidePassword,
} from '~/assets/svgs/index';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 2rem;

  @media (max-width: 600px) {
    justify-content: center;
  }

  @media (min-width: 600px) {
    margin-left: 12rem;
    margin-right: 12rem;
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  flex-wrap: wrap;
`;

export const BG = styled(ForgotPasswordBG)`
  position: absolute;
  z-index: 0;

  width: 100%;
  height: 100%;

  opacity: 0.2;
`;

export const Logo = styled.img`
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;

  height: 140px;
`;

export const Content = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media (min-width: 600px) {
    justify-content: space-between;
  }

  margin-top: 7.5rem;
`;

export const TitleWrapper = styled.div`
  @media (min-width: 600px) {
    flex: 1 1 30%;
  }
`;

export const FormWrapper = styled.div`
  flex: 0 1 30%;
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.blue};

  font-family: ${({ theme }) => theme.fonts.Poppins};
  font-size: 7.5rem;
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  @media (max-width: 600px) {
    display: none;
  }
`;

export const WrapperProgress = styled.div`
  margin-bottom: 2.7rem;
`;

export const ForgotPasswordText = styled.p`
  font-family: ${({ theme }) => theme.fonts.Poppins};
  font-size: 2.8rem;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  line-height: 4rem;
  color: ${({ theme }) => theme.colors.blue};

  margin-top: 4rem;
`;

export const ForgotPasswordInstruction = styled.p`
  font-family: ${({ theme }) => theme.fonts.Poppins};
  font-size: 1.4rem;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  line-height: 2rem;

  margin-bottom: 4.5rem;
  margin-top: 1rem;
`;

export const PasswordWrapper = styled.div`
  position: relative;
`;

export const ShowPasswordIcon = styled(IconShowPassword)`
  position: absolute;
  top: 2rem;
  right: 1.5rem;
  cursor: pointer;
`;

export const HidePasswordIcon = styled(IconHidePassword)`
  position: absolute;
  top: 2rem;
  right: 1.5rem;
  cursor: pointer;
`;
